import type { IDropDownItem } from "@similarweb/ui-components";
import {
    StyledSingleSelectDDItem,
    StyledSingleSelectDDItemText,
} from "app/pages/sales-intelligence/common-components/dropdown/styles";

type Props = IDropDownItem;

const ThresholdListItem = ({ text, ...restItemProps }: Props) => {
    return (
        <StyledSingleSelectDDItem {...restItemProps}>
            <StyledSingleSelectDDItemText data-automation="traffic-threshod-item-text">
                {text}
            </StyledSingleSelectDDItemText>
        </StyledSingleSelectDDItem>
    );
};

export default ThresholdListItem;
